<template>
    <div class="login-modal error-modal" style="display: flex; z-index: 10000">
        <div class="modal1_content-wrapper-long alt mobile-height">
            <div class="modal-content">
                <a-result status="500" title="500" sub-title="Looks like something went wrong on our end. Our team has been alerted and we're working to fix it. Please try again shortly.">
                    <template #extra>
                        <div class="error-modal-buttons">
                            <button 
                                @click="reload" 
                                class="button form_button w-button error-modal-btn"
                            >
                                Reload
                            </button>
                        </div>
                    </template>
                </a-result>
            </div>
        </div>
        <div class="modal1_background-overlay color"></div>
    </div>
</template>
<script>
export default {
    methods: {
        reload() {
            // Remove the error modal container before reloading
            const container = document.getElementById('something-went-wrong-container');
            if (container) {
                document.body.style.overflow = '';
                container.remove();
            }
            globalThis.location.reload();
        },
    },
};
</script>
<style src="./error-modal.css"></style>